import { render, staticRenderFns } from "./IconAlert.vue?vue&type=template&id=25c7010c&"
import script from "./IconAlert.vue?vue&type=script&lang=js&"
export * from "./IconAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports